import { writable } from "svelte/store";
import { createDefaultSettings, createLetterStates } from "./utils";
export const mode = writable();
export const letterStates = writable(createLetterStates());
export const settings = writable(createDefaultSettings());
